/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*
 * Zokos (carried over from the Warehouse 1.16.9 theme): on screens up to 1000px wide, show the
 * product gallery inside the product info card, between the title/price and the option picker,
 * instead of above the card. layout/theme.liquid loads this file before theme.js, so the gallery is
 * in place before the theme initialises it. The theme's variant re-render only swaps the blocks it
 * owns, so the moved gallery stays put. If an element is missing, the default layout is kept.
 */
(function () {
  if (window.innerWidth > 1000 || !document.body.classList.contains('template-product')) {
    return;
  }

  var section = document.querySelector('[data-section-type="product"]');
  var gallery = section && section.querySelector('.product-block-list__item--gallery');
  var info = section && section.querySelector('.product-block-list__item--info');
  var target = info && (info.querySelector('.product-info__block-item--variant-selector') || info.querySelector('.product-info__block-item--buy-buttons'));

  if (!gallery || !target) {
    return;
  }

  target.parentNode.insertBefore(gallery, target);
  gallery.classList.add('zokos-mobile-gallery');

  // The gallery now sits inside the product form, where a button without a type submits the form
  // (adds to cart). Its zoom close/prev/next and 3D buttons have no type, so make them plain buttons.
  Array.prototype.forEach.call(gallery.querySelectorAll('button:not([type])'), function (button) {
    button.type = 'button';
  });
})();


/*
 * Zokos: live product counts on the homepage (sections/zokos-hero.liquid and zokos-departments.liquid).
 * Liquid caps product counts at 25,001, so those sections mark larger counts with data-zk-count-url
 * (the collection's storefront JSON) and this fills in the real number, rounded down the same way as
 * snippets/zokos-count.liquid (35,477 -> "35,000+"). The section's own text stays if the request fails.
 */
(function () {
  var counts = document.querySelectorAll('[data-zk-count-url]');

  Array.prototype.forEach.call(counts, function (element) {
    fetch(element.getAttribute('data-zk-count-url'), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var count = data && data.collection && data.collection.products_count;

        if (!count) {
          return;
        }

        var shown = count >= 10000 ? Math.floor(count / 1000) * 1000 : count >= 1000 ? Math.floor(count / 100) * 100 : count;
        element.textContent = shown.toLocaleString('en-US') + (count > shown ? '+' : '');
      })
      .catch(function () {});
  });
})();


/*
 * Zokos: load the product grid of tag-filtered collections (/collections/hardware/condition_used).
 * Shopify's product query on those is slow until it is cached and can stall the whole page into a 500,
 * so sections/main-collection.liquid leaves the cards out of the full page and shows a "Loading
 * products…" note (data-zokos-products-retry); the note also replaces a grid whose query failed.
 * This fetches the collection section (Section Rendering API, the same request the theme makes when
 * sorting or paging), retrying while the query is still cold, and swaps in the first result that has
 * products. It also runs after the theme's own reloads. If every try fails, a "Try again" button shows.
 */
(function () {
  var section = document.querySelector('[data-section-type="collection"]');

  if (!section) {
    return;
  }

  // The first fetch runs at once; the retries give Shopify time to finish caching the query
  var delays = [0, 1000, 2000, 4000, 8000, 12000];
  var attempt = 0;
  var generation = 0;
  var busy = false;
  var timer = null;

  function placeholder() {
    return section.querySelector('.collection__dynamic-part [data-zokos-products-retry]');
  }

  function showFailure(element) {
    element.querySelector('[data-zokos-retry-loading]').hidden = true;
    element.querySelector('[data-zokos-retry-failed]').hidden = false;
  }

  function scheduleRetry() {
    var element = placeholder();

    if (busy) {
      return;
    }

    if (!element) {
      attempt = 0;
      return;
    }

    if (attempt >= delays.length) {
      showFailure(element);
      return;
    }

    busy = true;
    timer = setTimeout(reloadProducts, delays[attempt++], generation);
  }

  function reloadProducts(startedIn) {
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', section.getAttribute('data-section-id'));
    // A fresh URL per try, so a cached copy of the failed render is never served again
    url.searchParams.set('zokos_retry', Date.now());

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        // The theme started its own reload (sort, page) in the meantime: its result wins
        if (startedIn !== generation) {
          return;
        }

        busy = false;

        var temp = document.createElement('div');
        temp.innerHTML = html;

        var fresh = temp.querySelector('.collection__dynamic-part');
        var current = section.querySelector('.collection__dynamic-part');

        if (fresh && current && !fresh.querySelector('[data-zokos-products-retry]')) {
          current.innerHTML = fresh.innerHTML;
          attempt = 0;
          return;
        }

        scheduleRetry();
      })
      .catch(function () {
        if (startedIn === generation) {
          busy = false;
          scheduleRetry();
        }
      });
  }

  section.addEventListener('click', function (event) {
    var button = event.target.closest('[data-zokos-retry-button]');

    if (!button) {
      return;
    }

    var element = placeholder();

    if (!element || busy) {
      return;
    }

    element.querySelector('[data-zokos-retry-failed]').hidden = true;
    element.querySelector('[data-zokos-retry-loading]').hidden = false;
    attempt = 0;
    busy = true;
    reloadProducts(generation);
  });

  document.addEventListener('theme:loading:start', function () {
    clearTimeout(timer);
    generation++;
    attempt = 0;
    busy = false;
  });

  document.addEventListener('theme:loading:end', scheduleRetry);

  scheduleRetry();
})();
